import React from 'react';
import { withTranslation } from 'react-i18next/hooks';

import theme from '../../../theme';
import {Table, TableBody, TableCell, TableHead, TableRow}  from '@material-ui/core';
import {Paper, IconButton, Menu, MenuItem, ListItemIcon, ListItemText} from '@material-ui/core';
import MoreVert from '@material-ui/icons/MoreVert';
import EditIcon from '@material-ui/icons/Edit';
import AddCircleOutlineIcon from '@material-ui/icons/AddCircleOutline';
import DeleteForeverIcon from '@material-ui/icons/DeleteForever';
import { sortByName } from '../../../api/helpers';

class ProfilesListEditor_ extends React.Component{

    constructor(props){
        super(props);
        this.state = {menuAnchor: null}
    }

    handleItemSelect(itemID){
        this.props.onItemSelect(itemID)
    }

    getItemStyle(itemID){
        let selected = itemID === this.props.selectedItemID
        let style = {
            background: selected? theme.palette.background.selectedRow : '',
            cursor: 'pointer'
        }
        return style
    }

    handleMenuClick(event, itemID){
        this.setState({menuAnchor: event.currentTarget, menuItemID: itemID});
        event.stopPropagation();
    }

    handleMenuClose(){
        this.menuAnchor = null;
        this.setState({menuAnchor: null});
        return null;
    }

    handleMenuItemClick(action, ProfileID){
        const itemID = ProfileID ? ProfileID : this.state.menuItemID
        this.handleMenuClose();
        this.props.onAction({type: action, profileID: itemID})
    }

    render(){
        const {t} = this.props

        this.props.items.sort(sortByName)

        const styles = {
            paper: {
              width: '100%',
              overflowX: 'auto',
            },
            head: {
                color: theme.palette.color.dialogTitle,
                backgroundColor: theme.palette.background.dialogTitle,
            },
            addIcon: {
                color: 'white'
            }
        };

        return(
            <>
                <Paper style={styles.paper}>
                    <Table size="small">
                        <TableHead>
                            <TableRow>
                                <TableCell style={styles.head}>{t('Name')}</TableCell>
                                <TableCell style={styles.head}>{t('Description')}</TableCell>
                                <TableCell style={{...styles.head, width:40}}>
                                    <IconButton size="small" color="primary" aria-label="add profile" component="span"
                                        style={styles.addIcon}
                                        onClick={()=>{this.handleMenuItemClick('PROFILE_EDITOR_OPEN_ADD')}}>
                                        <AddCircleOutlineIcon />
                                    </IconButton>
                                </TableCell>
                            </TableRow>
                            

                        </TableHead>
                        <TableBody>
                        {this.props.items.map((item) => 
                            <TableRow key={item.ProfileID} 
                                    onClick={()=>{this.handleItemSelect(item.ProfileID)}}
                                    onDoubleClick={()=>{this.handleMenuItemClick('PROFILE_EDITOR_OPEN_EDIT', item.ProfileID)}}
                                    style={this.getItemStyle(item.ProfileID)}>
                                <TableCell component="th" scope="row">
                                  {item.Name}
                                </TableCell>
                                <TableCell>
                                    {item.Description}
                                </TableCell>
                                <TableCell style={{width:40}}>
                                    <IconButton size="small" color="inherit" aria-label="add" component="span"
                                        onClick={event=>this.handleMenuClick(event, item.ProfileID)}>
                                        <MoreVert />
                                    </IconButton>
                                </TableCell>
                            </TableRow>
                        )}
                        </TableBody>
                        <Menu anchorEl={this.state.menuAnchor} keepMounted
                            open={Boolean(this.state.menuAnchor)} onClose={this.handleMenuClose.bind(this)}>
                            <MenuItem onClick={()=>{this.handleMenuItemClick('PROFILE_EDITOR_OPEN_EDIT')}}>
                                <ListItemIcon color="primary"><EditIcon/></ListItemIcon> 
                                <ListItemText primary={t('EditProfile')+'...'} />
                            </MenuItem>
                            <MenuItem onClick={()=>{this.handleMenuItemClick('PROFILE_EDITOR_DELETE')}}>
                                <ListItemIcon><DeleteForeverIcon/></ListItemIcon>
                                <ListItemText primary={t('DeleteProfile')} />
                            </MenuItem>
                        </Menu>
                    </Table>
                </Paper>
            </>
        )

    }

}

export const ProfilesListEditor = withTranslation()(ProfilesListEditor_);